<template>
  <div>
    <page-main
      ref="pageMain"
      :tableData="tableData"
      :loading="loading"
      :orderCode="orderCode"
      @openEditDialog="openEditDialog"
      @reload="getData"
    >
    </page-main>
    <DetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="$l('INDEX.dialog_title_inspection_detail') || '查看验货要求'"
      :orderInspectionCode="detailDialogOptions.code"
    />
  </div>
</template>
<script>
import PageMain from './main'
import DetailDialog from '../detail/dialog.vue'
export default {
  props: { orderCode: { type: String, default: '' } },
  components: { PageMain, DetailDialog },
  data() {
    return {
      tableData: [],
      loading: false,
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .pendingOrderInspectionListApi({ orderCode: this.orderCode })
        .then((res) => {
          this.tableData = res.body.data
          this.loading = false
        })
    },
    openEditDialog({ orderInspectionCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderInspectionCode,
      }
    },
  },
}
</script>
